// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-popup-parent--hidden .fixed-header {\n  padding-right: 15px;\n}\n.app-fullscreen-wrapper .kv-editor {\n  height: calc(100vh - 82px) !important;\n}\n.app-fullscreen-wrapper .container[data-v-4c9bc147] {\n  width: 100%;\n  height: 100vh !important;\n}\n.app-fullscreen-wrapper .pages-view {\n  height: 100%;\n}", ""]);
// Exports
module.exports = exports;
